import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/driver";

export default class DriversService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
